import React from "react";
import "./App.css";
import AboutModule from "./Components/AboutModule";
import MainContent from "./Components/MainContent";
import MainNav from "./MainHeader/MainNav";
import Services from "./Components/Services";
import Contact from "./Components/Contact";
import FooterSection from "./Components/FooterSection";
import Portfolio from "./Components/Portfolio";
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <main>
        <Routes>
          <Route path="/" element={<MainContent />}>
            <Route index element={<AboutModule />} />
            <Route path="/skills" element={<Services />} />
            <Route path="/projects" element={<Portfolio />} />
            <Route path="/contactme" element={<Contact />} />
          </Route>
        </Routes>
      </main>
      <footer>
        <FooterSection />
      </footer>
    </div>
  );
}

export default App;
